import { OrganizacaoSimples } from "./organizacao.interface";
import { UnidadeSimples } from "./unidade.interface";
import { Usuario } from "./usuario.interface";

export class Paciente implements Usuario {
  id?: string;
  primeiro_nome: string;
  sobrenome: string;
  idade: string | Date;
  endereco: string;
  cidade: string;
  estado: string;
  telefone: string;
  whatsapp?: string;
  name_instagram?: string;

  email: string;
  tipo_usuario: 'paciente'; 
  url?: string;
  url_paciente?: string;
  plano_de_saude: string;
  qual_plano: string;
  medico: string;
  telefone_medico: string;
  crm: string;
  cns?: string;
  cpf?: string;
  enfermeiro: string;
  telefone_enfermeiro: string;
  medico_app: string;
  enfermeiro_app: string;
  cartao_gestante?: CartaoGestante[];
  ultimo_cartao?: CartaoGestante;
  orgs?: Array<OrganizacaoSimples>;
  unidades?: Array<UnidadeSimples>;

  constructor(paciente: Paciente) {
    this.url = paciente.url,
    this.url_paciente = paciente.url_paciente,
    this.primeiro_nome = paciente.primeiro_nome,
    this.sobrenome = paciente.sobrenome,
    this.email = paciente.email,
    this.idade = paciente.idade,
    this.endereco = paciente.endereco,
    this.cidade = paciente.cidade,
    this.estado = paciente.estado,
    this.telefone = paciente.telefone,
    this.whatsapp = paciente.whatsapp,
    this.name_instagram = paciente.name_instagram,
    this.plano_de_saude = paciente.plano_de_saude,
    this.qual_plano = paciente.qual_plano,
    this.medico = paciente.medico,
    this.enfermeiro = paciente.enfermeiro,
    this.crm = paciente.crm,
    this.cns = paciente.cns,
    this.cpf = paciente.cpf,
    this.telefone_medico = paciente.telefone_medico,
    this.medico_app = paciente.medico_app,
    this.telefone_enfermeiro = paciente.telefone_enfermeiro,
    this.enfermeiro_app = paciente.enfermeiro_app,
    this.tipo_usuario = 'paciente',
    this.cartao_gestante = [],
    this.orgs = paciente.orgs,
    this.unidades = paciente.unidades
  }

  static create(paciente: {
    url: string,
    url_paciente?: string,
    primeiro_nome: string,
    sobrenome: string,
    email: string,
    idade: string,
    endereco: string,
    cidade: string,
    estado: string,
    telefone: string,
    whatsapp?: string;
    name_instagram?: string;
    plano_de_saude: string,
    qual_plano: string,
    crm: string,
    cns?: string,
    cpf?: string,
    enfermeiro: string;
    telefone_enfermeiro: string;
    enfermeiro_app: string;
    medico: string,
    telefone_medico: string,
    medico_app: string,
    tipo_usuario: 'paciente',
    cartao_gestante?: CartaoGestante[],
    orgs?: Array<OrganizacaoSimples>;
    unidades?: Array<UnidadeSimples>;
  }):Paciente {
    return {
      url: paciente.url,
      url_paciente: paciente.url_paciente,
      primeiro_nome: paciente.primeiro_nome,
      sobrenome: paciente.sobrenome,
      email: paciente.email,
      idade: paciente.idade,
      endereco: paciente.endereco,
      cidade: paciente.cidade,
      estado: paciente.estado,
      telefone: paciente.telefone,
      whatsapp: paciente.whatsapp,
      name_instagram: paciente.name_instagram,
      plano_de_saude: paciente.plano_de_saude,
      qual_plano: paciente.qual_plano,
      medico: paciente.medico,
      enfermeiro: paciente.enfermeiro,
      crm: paciente.crm,
      cns: paciente.cns,
      cpf: paciente.cpf,
      telefone_medico: paciente.telefone_medico,
      medico_app: paciente.medico_app,
      telefone_enfermeiro: paciente.telefone_enfermeiro,
      enfermeiro_app: paciente.enfermeiro_app,
      tipo_usuario: 'paciente',
      cartao_gestante: [],
      orgs: paciente.orgs,
      unidades: paciente.unidades
    };
  }

  static createEmpty():Paciente {
    return {
      url: '',
      primeiro_nome: '',
      sobrenome: '',
      email: '',
      idade: new Date(),
      endereco: '',
      cidade: '',
      estado: '',
      telefone: '',
      plano_de_saude: '',
      qual_plano: '',
      crm: '',
      cns: '',
      cpf: '',
      enfermeiro: '',
      enfermeiro_app: '',
      telefone_enfermeiro: '',
      medico: '',
      medico_app: '',
      telefone_medico: '',
      tipo_usuario: 'paciente',
      cartao_gestante: [],
      orgs: [],
      unidades: []
    };
  }
}

export class CartaoGestante {
  id?: string;
  used?: boolean;
  paciente?: string;
  medico?: string;
  enfermeiro?: string;
  ativado: boolean;
  encerrado: boolean;
  criado_em: any;
  data_concepcao: Date | string;
  consultas: ConsultaPaciente[];
  historico_clinico: HistoricoClinico;
  historico_familiar: HistoricoFamiliar;
  sobre_a_gestacao: SobreAGestacao;
  vacinas: Vacinas;
  exames: Exames;
  arquivos_analisados: ArquivoAnalisado[];
  antecedentes_obstetricos: AntecedentesObstetricos;
  previsao_parto_dum: string | Date;
  previsao_parto_ultrassom: string | Date;
  fim_data: string | Date;
  fim_hora: string;
  fim_parto: string;
  fim_info: string;
  org?: string;
  org_name?: string;

  constructor() {
    this.ativado = true,
    this.criado_em = new Date(),
    this.data_concepcao = '',
    this.consultas = [],
    this.historico_clinico = HistoricoClinico.create(),
    this.historico_familiar = HistoricoFamiliar.create(),
    this.sobre_a_gestacao = SobreAGestacao.create(),
    this.vacinas = Vacinas.create(),
    this.exames = Exames.create(),
    this.arquivos_analisados = [],
    this.antecedentes_obstetricos = AntecedentesObstetricos.create(),
    this.previsao_parto_dum = '',
    this.previsao_parto_ultrassom = '',
    this.encerrado = false,
    this.fim_data = '',
    this.fim_hora = '',
    this.fim_parto = '',
    this.fim_info = ''
  }

  static create() {
    return {
      ativado: true,
      criado_em: new Date(),
      data_concepcao: '',
      consultas: [],
      historico_clinico: HistoricoClinico.create(),
      historico_familiar: HistoricoFamiliar.create(),
      sobre_a_gestacao: SobreAGestacao.create(),
      vacinas: Vacinas.create(),
      exames: Exames.create(),
      arquivos_analisados: [],
      antecedentes_obstetricos: AntecedentesObstetricos.create(),
      previsao_parto_dum: '',
      previsao_parto_ultrassom: '',
      encerrado: false,
      fim_data: '',
      fim_hora: '',
      fim_parto: '',
      fim_info: ''
    };
  }

}

export class ConsultaPaciente {
  id?: string;
  nome_paciente?: string;
  data: Date;
  hora?: string;
  medico_id: string;
  paciente_id: string;
  cartao_paciente_id: string;
  ig_dum: string;
  ig_usg: string;
  peso: string;
  pa: string;
  au: string;
  bcf: string;
  mf: string;
  edema: string;
  anotacoes_gerais: string;

  constructor() {
    this.data = new Date();
    this.hora = '';
    this.medico_id = '';
    this.paciente_id = '';
    this.cartao_paciente_id = '';
    this.ig_dum = '';
    this.ig_usg = '';
    this.peso = '';
    this.pa = '';
    this.au = '';
    this.bcf = '';
    this.mf = '';
    this.edema = '';
    this.anotacoes_gerais = '';
  }
  
  static create(consulta_form: {
    data: Date,
    hora: string,
    ig_dum: string,
    ig_usg: string,
    peso: string,
    pa: string,
    au: string,
    bcf: string,
    mf: string,
    edema: string,
    anotacoes_gerais: string,
  }, medico_email: string, paciente_email: string, cartao_id: string) {
    var nova_data: any = `${consulta_form.data.getFullYear()}-${consulta_form.data.getMonth() + 1}-${consulta_form.data.getDate()} `;
    if (consulta_form.hora && consulta_form.hora != null) {
      nova_data += consulta_form.hora;
      nova_data = new Date(nova_data);
    } else {
      nova_data = consulta_form.data;
    }
    return {
      data: nova_data,
      medico_id: medico_email,
      paciente_id: paciente_email,
      cartao_paciente_id: cartao_id,
      ig_dum: consulta_form.ig_dum,
      ig_usg: consulta_form.ig_usg,
      peso: consulta_form.peso,
      pa: consulta_form.pa,
      au: consulta_form.au,
      bcf: consulta_form.bcf,
      mf: consulta_form.mf,
      edema: consulta_form.edema,
      anotacoes_gerais: consulta_form.anotacoes_gerais
    };
  }

  static createEmpty() {
    return {
      data: new Date(),
      medico_id: '',
      paciente_id: '',
      cartao_paciente_id: '',
      ig_dum: '',
      ig_usg: '',
      peso: '',
      pa: '',
      au: '',
      bcf: '',
      mf: '',
      edema: '',
      anotacoes_gerais: ''
    };
  }
}

export class HistoricoClinico {
  alcoolismo: string;
  alergia: string;
  anemia: string;
  aque: string;
  cardiopatia: string;
  diabetes: string;
  hipertensao: string;
  outros: string;
  tabagismo: string;

  constructor() {
    this.alcoolismo = '';
    this.alergia = '';
    this.anemia = '';
    this.aque = '';
    this.cardiopatia = '';
    this.diabetes = '';
    this.hipertensao = '';
    this.outros = '';
    this.tabagismo = '';
  }

  static create() {
    return {
      alcoolismo: '',
      alergia: '',
      anemia: '',
      aque: '',
      cardiopatia: '',
      diabetes: '',
      hipertensao: '',
      outros: '',
      tabagismo: ''
    };
  }
}

export class HistoricoFamiliar {
  diabetes: string;
  eplepsia: string;
  gemelaridade: string;
  hipertensao: string;
  malformacao: string;
  outros: string;

  constructor() {
    this.diabetes = '';
    this.eplepsia = '';
    this.gemelaridade = '';
    this.hipertensao = '';
    this.malformacao = '';
    this.outros = '';
  }

  static create() {
    return {
      diabetes: '',
      eplepsia: '',
      gemelaridade: '',
      hipertensao: '',
      malformacao: '',
      outros: '',
    };
  }
}

export class SobreAGestacao {
  alteracoes: string;
  dum: string | Date;
  us1: string | Date;
  us_semanas: string;
  us_dias: string;
  tsabo: string;
  rh: string;
  peso_inicial: string;
  estatura: string;
  exame_clinico: string;
  exame_mamas: string;
  exame_ginecologico: string;

  constructor() {
    this.alteracoes = '';
    this.dum = '';
    this.us1 = '';
    this.us_semanas = '';
    this.us_dias = '';
    this.tsabo = '';
    this.rh = '';
    this.peso_inicial = '';
    this.estatura = '';
    this.exame_clinico = '';
    this.exame_mamas = '';
    this.exame_ginecologico = '';
  }

  static create() {
    return {
      alteracoes: '',
      dum: '',
      us1: '',
      us_semanas: '',
      us_dias: '',
      tsabo: '',
      rh: '',
      peso_inicial: '',
      estatura: '',
      exame_clinico: '',
      exame_mamas: '',
      exame_ginecologico: '',
    };
  }
}

export class Vacinas {
  colpo_data: string | Date;
  colpo_observacoes: string;
  colpo_resultado: string;
  dt_dose1: string | Date;
  dt_dose2: string | Date;
  dt_dose3: string | Date;
  dt_previa: string;
  hep_dose1: string | Date;
  hep_dose2: string | Date;
  hep_dose3: string | Date;
  hep_previa: string;
  tri_dose1: string | Date;
  tri_dose2: string | Date;
  tri_dose3: string | Date;
  tri_previa: string;

  constructor() {
    this.colpo_data = '';
    this.colpo_observacoes = '';
    this.colpo_resultado = '';
    this.dt_dose1 = '';
    this.dt_dose2 = '';
    this.dt_dose3 = '';
    this.dt_previa = '';
    this.hep_dose1 = '';
    this.hep_dose2 = '';
    this.hep_dose3 = '';
    this.hep_previa = '';
    this.tri_dose1 = '';
    this.tri_dose2 = '';
    this.tri_dose3 = '';
    this.tri_previa = '';
  }

  static create() {
    return {
      colpo_data: '',
      colpo_observacoes: '',
      colpo_resultado: '',
      dt_dose1: '',
      dt_dose2: '',
      dt_dose3: '',
      dt_previa: '',
      hep_dose1: '',
      hep_dose2: '',
      hep_dose3: '',
      hep_previa: '',
      tri_dose1: '',
      tri_dose2: '',
      tri_dose3: '',
      tri_previa: '',
    };
  }
}

export class AntecedentesObstetricos {
  complicacoes: string;
  g: number | null;
  p: number | null;
  a: number | null;

  constructor() {
    this.complicacoes = '';
    this.g = null;
    this.p = null;
    this.a = null;
  }

  static create() {
    return {
      complicacoes: '',
      g: null,
      p: null,
      a: null
    };
  }
}

export class Exames {
  clinicos: Array<ExameClinico>;
  laboratorio: Array<ExameLaboratorio>;
  ultrasom: Array<ExameUltrasom>;
  outros: any[];

  constructor() {
    this.clinicos = [],
    this.laboratorio = [],
    this.ultrasom = [],
    this.outros = []
  }

  static create() {
    return {
      clinicos: [],
      laboratorio: [],
      ultrasom: [],
      outros: []
    }
  }
}

export interface ExameClinico {
  apres: string;
  auca: string;
  bcf: string;
  data: Date | string;
  diag: string;
  obs: string;
  edema: string;
  hora: string;
  igdum: string;
  igusg: string;
  mov_fetal: string;
  pa: string;
  peso: string;
  id?: string | null;
}

export interface ExameUltrasom {
  data: Date | string;
  ig: string;
  peso_fetal: string;
  placenta: string;
  outros: string;
  arquivo_id: string | null;
}

export interface ExameLaboratorio {
  data_limite_tri1: string | null;
  data_limite_tri2: string | null;
  data_limite_tri3: string | null;
  datas: {
    data1: string | Date | null;
    data2: string | Date | null;
    data3: string | Date | null;
    res1: string | null;
    res2: string | null;
    res3: string | null;
  }
  name: string;
  arquivo_res1: string | null;
  arquivo_res2: string | null;
  arquivo_res3: string | null;
}

export interface Exame {
  name: string;
  res: {
    negativo?: boolean;
    positivo?: boolean;
    livre?: boolean
  };
}

export interface ArquivoAnalisado {
  id: string;
  blob_url: string;
  status: 'pendente' | 'processado' | 'utilizado';
  tipo: 'laboratorial' | 'ultrassom' | 'clinico' | 'outro';
  trimestre: string | null;
  data_envio: Date | string | null;
  data_realizacao: Date | string | null;
  resultado: any;
}

export interface AnalizePDFResponse {
  exams: ResultPDF[];
}

export interface AnalizePDFUltrasonograResponse {
  exams: ResultPDFUltrasonogra[];
}

export interface ResultPDF {
  arquivoId: string;
  fileName: string;
  results: ExameConfiance[];
}

export interface ExameConfiance {
  key: string;
  status: string;
  confidence: number;
  name: string;
  description?: string;
  result?: string;
  reference: string;
  data: string;
  used?: boolean;
}

export interface ResultPDFUltrasonogra {
  arquivoId: string;
  fileName: string;
  results: UltrasonografiaConfiance | UltrasonografiaConfiance[];
}

export interface UltrasonografiaConfiance {
  ig: string;
  peso_fetal: string;
  placenta: string;
  outros: string;
  data: string;
  confidence: number;
  used?: boolean;
}


export const dataExames: Array<Exame> = [{
  name: 'Outros',
  res: { livre: true }
}, {
  name: 'Plaquetas',
  res: { livre: true }
}, {
  name: 'HT/HB',
  res: { livre: true }
}, {
  name: 'TSH',
  res: { livre: true }
}, {
  name: 'Glicose em Jejum',
  res: { livre: true }
}, {
  name: 'TTOG (GTT)',
  res: { livre: true }
}, {
  name: 'Urina I',
  res: { livre: true }
}, {
  name: 'CMV IgG',
  res: { negativo: true, positivo: true }
}, {
  name: 'CMV IgM',
  res: { negativo: true, positivo: true }
}, {
  name: 'HIV',
  res: { negativo: true, positivo: true }
}, {
  name: 'VDRL',
  res: { negativo: true, positivo: true }
}, {
  name: 'HBsAG',
  res: { negativo: true, positivo: true }
}, {
  name: 'COOMBs Ind',
  res: { negativo: true, positivo: true }
}, {
  name: 'Toxo IgM',
  res: { negativo: true, positivo: true }
}, {
  name: 'Toxo IgG',
  res: { negativo: true, positivo: true }
}, {
  name: 'Rubéola IgM',
  res: { negativo: true, positivo: true }
}, {
  name: 'Rubéola IgG',
  res: { negativo: true, positivo: true }
}, {
  name: 'Cultura Streptococcus',
  res: { negativo: true, positivo: true }
}, {
  name: 'Hepatite C',
  res: { negativo: true, positivo: true }
}, {
  name: 'Urocultura',
  res: { negativo: true, positivo: true, livre: true }
}, {
  name: 'Protoparasitológico',
  res: { negativo: true, positivo: true, livre: true }
}, {
  name: 'ABO/Rh',
  res: { negativo: true, positivo: true, livre: true }
}, {
  name: 'Hepatite B',
  res: { negativo: true, positivo: true, livre: true }
}]
